<template>
  <div id="complienceSettings">
    <div class="modal-header-group">
      <span class="top-header-title">{{
        $t("journeyBuilder.flow.complianceSettings_title")
      }}</span>
      <svg
        class="close-modal-btn"
        @click="
          discardChangesBeforeClose(), $bvModal.hide('complianceSettings')
        "
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>

    <multiselect
      class="compliance-multiselect"
      v-model="selectedComplianceType"
      :options="compliancesTypes"
      :hideSelected="false"
      :allow-empty="false"
      :searchable="false"
      selectLabel=""
      deselectLabel=""
      placeholder="Compliance Type"
    />
    <ul class="content-list">
      <div
        v-for="(compliance, index) in compliances[selectedComplianceType]"
        :key="compliance.id"
      >
        <b-form-group
          :label="compliance.name[0].toUpperCase() + compliance.name.slice(1)"
        >
          <!-- start:: compliance setting -->
          <!-- Display options for document -->
          <template v-if="selectedComplianceType == 'Document - Vaccine/PCR'">
            <b-form-radio-group
              :id="compliance.id"
              :name="compliance.id"
              :options="documentOption"
              v-model="compliance.setting"
          /></template>
          <!-- Display options for questionnaire & agreement -->
          <template v-else>
            <b-form-radio-group
              :id="compliance.id"
              :name="compliance.id"
              :options="settingsOption"
              v-model="compliance.setting"
            />
          </template>
          <!-- end:: compliance setting -->

          <!-- start:: user type setting -->
          <div
            v-if="
              compliance &&
              compliance.metadata &&
              compliance.metadata.notification &&
              compliance.metadata.notification.length
            "
            class="user-type-setting-content"
          >
            <div
              v-for="(userType, indx) in compliance.metadata.notification"
              :key="userType.id"
            >
              <h5 class="user-type-name">{{ userType.name }}</h5>
              <div class="form-group d-flex justify-content-between">
                <p class="user-type-label">
                  {{
                    $t("journeyBuilder.flow.complianceSettings_sendBeforeVisit")
                  }}
                </p>
                <div
                  class="d-flex margin-end"
                  style="position: relative; bottom: 12px; min-width: 170px"
                  :class="{
                    'invalid-form-control':
                      formValidationObject[userType.classId] &&
                      (formValidationObject[userType.classId]
                        .emptyBeforePeriod ||
                        formValidationObject[userType.classId]
                          .invalidPriorPeriod),
                  }"
                >
                  <input
                    v-model="userType.periodOfTimeToSendBeforeVisit"
                    class="form-control user-type-input"
                    type="number"
                    pattern="\d*"
                    required
                    onKeyPress="if(this.value.length==3) return false;"
                    @keyup="formValidationCheck()"
                    @wheel.prevent
                  />
                  <div class="input-border-wrapper">
                    <div class="input-border"></div>
                  </div>
                  <multiselect
                    class="user-type-multiselect"
                    :options="userTypeSettingsOption"
                    v-model="userType.typeOfTimeToSendBeforeVisit"
                    trackBy="id"
                    label="text"
                    :preselect-first="true"
                    :hideSelected="false"
                    :allow-empty="false"
                    :searchable="false"
                    selectLabel=""
                    :show-labels="false"
                    deselectLabel=""
                    placeholder="Compliance Type"
                    @input="
                      updateSelectedOption(),
                        formValidationCheck(userType, $event)
                    "
                  />
                </div>
              </div>
              <div class="form-group d-flex justify-content-between">
                <p class="user-type-label">
                  {{
                    $t(
                      "journeyBuilder.flow.complianceSettings_sendReminderEvery"
                    )
                  }}
                </p>
                <div
                  class="d-flex margin-end"
                  style="position: relative; bottom: 12px; min-width: 170px"
                  :class="{
                    'invalid-form-control':
                      formValidationObject[userType.classId] &&
                      (formValidationObject[userType.classId]
                        .emptyReminderPeriod ||
                        formValidationObject[userType.classId]
                          .invalidReminderPeriod),
                  }"
                >
                  <input
                    class="form-control user-type-input"
                    v-model="userType.periodOfTimeToSendReminderVisit"
                    type="number"
                    pattern="\d*"
                    required
                    onKeyPress="if(this.value.length==3) return false;"
                    @keyup="formValidationCheck()"
                    @wheel.prevent
                  />
                  <div class="input-border-wrapper">
                    <div class="input-border"></div>
                  </div>
                  <multiselect
                    class="user-type-multiselect"
                    :options="userTypeSettingsOption"
                    v-model="userType.typeOfTimeToSendReminderVisit"
                    trackBy="id"
                    label="text"
                    :preselect-first="true"
                    :hideSelected="false"
                    :allow-empty="false"
                    :searchable="false"
                    :show-labels="false"
                    selectLabel=""
                    deselectLabel=""
                    placeholder="Compliance Type"
                    @input="formValidationCheck(userType, $event)"
                  />
                </div>
              </div>
              <hr
                class="user-type-separate-line"
                :class="{
                  hideDisplay: !compliance.metadata.notification[indx + 1],
                }"
              />
            </div>
          </div>
          <!-- end:: user type setting -->
        </b-form-group>
        <hr
          class="separate-line"
          :class="{
            hideDisplay: !compliances[selectedComplianceType][index + 1],
          }"
        />
      </div>
    </ul>

    <div>
      <p
        v-if="hasUserType"
        class="form-note"
        :class="{
          'invalid-form-error-text':
            Object.keys(formValidationObject).length > 0,
        }"
      >
        <b v-if="Object.keys(formValidationObject).length <= 0"
          >{{ $t("common.notes.note") }}:</b
        >
        {{ $t("journeyBuilder.flow.complianceSettings_complianceNote") }}
      </p>
      <button
        class="btn btn-primary px-3 save-btn"
        @click="$bvModal.hide('complianceSettings')"
        :disabled="Object.keys(formValidationObject).length > 0"
      >
        {{ $t("common.save") }}
      </button>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  components: { Multiselect },
  props: ["compliances"],
  data() {
    return {
      hasUserType: false,
      formValidationObject: {},
      invalidReminderSettingsIds: [],
      formValid: true,
      currentCompliancesSettings: {},
      groupedCompliances: {},
      compliancesTypes: [],
      selectedComplianceType: "",
      settingsOption: [
        {
          text: this.$t("journeyBuilder.flow.complianceSettings_everytime"),
          value: "every_time",
        },
        {
          text: this.$t("journeyBuilder.flow.complianceSettings_daily"),
          value: "daily",
        },
        {
          text: this.$t("journeyBuilder.flow.complianceSettings_weekly"),
          value: "weekly",
        },
        {
          text: this.$t("journeyBuilder.flow.complianceSettings_monthly"),
          value: "monthly",
        },
        {
          text: this.$t("journeyBuilder.flow.complianceSettings_oneoff"),
          value: "once_off",
        },
      ],
      documentOption: [
        {
          text: this.$t("journeyBuilder.flow.complianceSettings_everytime"),
          value: "every_time",
        },
        {
          text: this.$t("journeyBuilder.flow.complianceSettings_daily"),
          value: "daily",
        },
        {
          text: this.$t("journeyBuilder.flow.complianceSettings_weekly"),
          value: "weekly",
        },
        {
          text: this.$t("journeyBuilder.flow.complianceSettings_monthly"),
          value: "monthly",
        },
        {
          text: this.$t(
            "journeyBuilder.flow.complianceSettings_validTillExpiry"
          ),
          value: "Valid_till_expiry",
        },
      ],
      userTypeSettingsOption: [
        { id: 1, text: this.$t("common.minutes") },
        { id: 2, text: this.$t("common.hours") },
        { id: 3, text: this.$t("common.days") },
      ],
    };
  },
  watch: {},
  methods: {
    getAllSettings() {
      let settings = [];
      for (let key in this.compliances) {
        this.compliances[key].forEach((complianceType) => {
          settings.push(...complianceType.metadata.notification);
        });
      }
      return settings;
    },
    formValidationCheck() {
      this.formValid = true;

      const settings = this.getAllSettings();
      settings.forEach((setting) => {
        const classId = setting.classId.toString();
        const classIdExistInValidationObject = this.formValidationObject[
          classId
        ]
          ? true
          : false;

        /**
         *
         * Validation rules:
         *  -Reminder period must be bigger than or equal 30
         *  -Time before visit must be bigger than or equal 5 mins
         *  -Time before visit cannot be empty or equals 0
         *  -Reminder time cannot be empty ot equals 0
         *
         * @Ex. if all validations fail on first user type
         *  formValidationObject ={
         *   "0" :{
         *        'invalidReminderPeriod' : 1,
         *        'emptyBeforePeriod' :1,
         *        'invalidPriorPeriod' :1
         *        'emptyReminderPeriod': 1
         *      }
         *    }
         */

        //Check for invalid reminder duration (duration < 30)
        if (
          setting.periodOfTimeToSendReminderVisit < 30 &&
          setting.typeOfTimeToSendReminderVisit.id == 1
        ) {
          //Add object key (class id) if does not exist
          //or add to currently existing if found
          if (classIdExistInValidationObject) {
            Object.assign(this.formValidationObject[classId], {
              invalidReminderPeriod: 1,
            });
          } else {
            Object.assign(this.formValidationObject, {
              [classId]: { invalidReminderPeriod: 1 },
            });
          }
        } else {
          //remove key
          if (
            this.formValidationObject[classId] &&
            this.formValidationObject[classId].invalidReminderPeriod
          ) {
            delete this.formValidationObject[classId].invalidReminderPeriod;
          }
        }

        //Check for invalid time before visit duration (duraction < 5 mins)
        if (
          setting.periodOfTimeToSendBeforeVisit < 5 &&
          setting.typeOfTimeToSendBeforeVisit.id == 1
        ) {
          if (classIdExistInValidationObject) {
            Object.assign(this.formValidationObject[classId], {
              invalidPriorPeriod: 1,
            });
          } else {
            Object.assign(this.formValidationObject, {
              [classId]: { invalidPriorPeriod: 1 },
            });
          }
        } else {
          if (
            this.formValidationObject[classId] &&
            this.formValidationObject[classId].invalidPriorPeriod
          ) {
            delete this.formValidationObject[classId].invalidPriorPeriod;
          }
        }

        //Check if time before visit is empty or equals 0
        if (
          parseInt(setting.periodOfTimeToSendBeforeVisit) <= 0 ||
          !setting.periodOfTimeToSendBeforeVisit
        ) {
          if (classIdExistInValidationObject) {
            Object.assign(this.formValidationObject[classId], {
              emptyBeforePeriod: 1,
            });
          } else {
            Object.assign(this.formValidationObject, {
              [classId]: { emptyBeforePeriod: 1 },
            });
          }
        } else {
          if (
            this.formValidationObject[classId] &&
            this.formValidationObject[classId].emptyBeforePeriod
          ) {
            delete this.formValidationObject[classId].emptyBeforePeriod;
          }
        }

        //Check if reminder is empty or equals 0
        if (
          parseInt(setting.periodOfTimeToSendReminderVisit) <= 0 ||
          !setting.periodOfTimeToSendReminderVisit
        ) {
          if (classIdExistInValidationObject) {
            Object.assign(this.formValidationObject[classId], {
              emptyReminderPeriod: 1,
            });
          } else {
            Object.assign(this.formValidationObject, {
              [classId]: { emptyReminderPeriod: 1 },
            });
          }
        } else {
          if (
            this.formValidationObject[classId] &&
            this.formValidationObject[classId].emptyReminderPeriod
          ) {
            delete this.formValidationObject[classId].emptyReminderPeriod;
          }
        }

        //delete whole class object if no errors found in that class id object
        if (
          this.formValidationObject[classId] &&
          !Object.keys(this.formValidationObject[classId]).length
        ) {
          delete this.formValidationObject[classId];
        }
      });
      this.$forceUpdate();
    },
    updateSelectedOption() {
      this.$forceUpdate();
    },
    discardChangesBeforeClose() {
      this.$emit("complianceSettingsCanceled", this.currentCompliancesSettings);
    },
  },
  beforeMount() {
    //store current state of compliance settings
    this.currentCompliancesSettings = JSON.parse(
      JSON.stringify(this.compliances)
    );

    //Assign compliance type select options
    this.compliancesTypes = Object.keys(
      JSON.parse(JSON.stringify(this.compliances))
    );

    //Set default selected option to first option
    this.selectedComplianceType =
      this.compliancesTypes && this.compliancesTypes.length
        ? this.compliancesTypes.at(0)
        : "";

    //set id to every compliance notification setting object
    this.getAllSettings().forEach((comSetting, indx) => {
      this.hasUserType = true;
      Object.assign(comSetting, { classId: indx });
    });
  },
};
</script>
<style lang="scss">
#complienceSettings {
  //scrollbar
  .content-list {
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: 350px;
  }
  .content-list::-webkit-scrollbar {
    width: 9px;
  }
  .content-list::-webkit-scrollbar-track {
    background: #c7c7c7;
    height: 129px;
    border-radius: 8.5px;
    -webkit-box-shadow: #ffff;
  }
  .content-list::-webkit-scrollbar-thumb {
    background: #666666;
    border-radius: 8.5px;
    height: 50px;
  }

  //Modal header
  .modal-header-group {
    width: 100%;
    text-align: center;
    margin: 33px auto 38px auto;
    span.top-header-title {
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      text-align: center;
      color: #000000;
    }
  }

  .top-header-title {
    font-weight: 700;
    font-size: 20px;
    line-height: 20px;
    letter-spacing: 0.25px;
  }

  //radio group label (title)
  .col-form-label {
    color: #939393;

    font-weight: 700;
    font-size: 16px;
    line-height: 19.2px;
  }

  //radio button label
  .custom-control-label {
    color: #606060;

    font-weight: 400;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
    min-width: 90px;
    margin-top: 25px;
    span {
      margin-inline-start: 10px;
      top: 0;
    }
  }

  .custom-control-label::before {
    width: 20px;
    height: 20px;
    background: #c7c7c7;
    margin-top: -3px;
    border: 0 !important;
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #103f5e !important;
    z-index: 1;
    border: 3px solid #c7c7c7 !important;
  }

  .user-type-setting-content {
    margin-top: 35px;
  }
  .user-type-name {
    font-weight: 700;
    line-height: 19.2px;
    color: #939393;
    margin-bottom: 31px;
  }

  .user-type-label {
    font-size: 16px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: #606060;
    opacity: 0.8;
  }

  .user-type-input {
    width: 85px;
    background-color: #f2f2f2;
    height: 44px;
    border: 0px;
    border-start-start-radius: 4px;
    border-end-start-radius: 4px;
    border-start-end-radius: 0px !important;
    border-end-end-radius: 0px !important;

    font-weight: 400;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: #606060de;
    text-align: center;
  }

  .user-type-multiselect {
    border-radius: 20px;
    .multiselect__select {
      z-index: 5;
      margin-inline-start: 15px;
    }
    .multiselect__tags {
      margin-top: 0px !important;
      border: 0px !important;
      height: 44px;
      width: 85px;
    }
    .multiselect__single {
      font-size: 16px !important;
      font-weight: 700;
      line-height: 17px;
      letter-spacing: 0.25px;
      position: relative;
      inset-inline-end: 3px;
      top: 6px;
    }
    .multiselect__tags,
    .multiselect__single {
      background-color: #f2f2f2 !important;
      border-start-end-radius: 4px;
      border-end-end-radius: 4px;
      border-start-start-radius: 0px;
      border-end-start-radius: 0px;
    }
  }
  //Buttons
  .close-modal-btn {
    position: relative;
    bottom: 37px;
    inset-inline-start: 107px;
  }

  .save-btn {
    width: 100%;
    border-radius: 22px;
    height: 44px;

    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
  }

  .form-group {
    margin-top: 20px;
  }

  .form-note {
    width: 400px;

    font-size: 14px;
    line-height: 22.5px;
    letter-spacing: 0.25px;
    text-align: center;
    font-weight: 400;
    color: #939393;
    opacity: 0.8;
    b {
      font-weight: 700;
    }
  }
  .invalid-form-error-text {
    color: #f46a6a;
  }

  //Helpers
  .invalid-form-control {
    border: 1px solid red;
    border-radius: 4px;
  }

  .reminder-invalid-msg {
    font-size: 10px;
    color: red;
    position: relative;
    bottom: 10px;
    max-width: 160px;
    margin: 0;
  }

  .hideDisplay {
    display: none;
  }

  .compliance-multiselect {
    margin-bottom: 45px;
    .multiselect__select {
      z-index: 5;
      margin-top: 5px;
    }
    .multiselect__tags {
      border: 0px !important;
      height: 55px;
      margin-top: 0px !important;
    }
    .multiselect__single {
      position: relative;
      top: 11px;
      inset-inline-start: 12px;

      font-size: 18px !important;
      font-weight: 700;
      line-height: 17px;
      letter-spacing: 0.25px;
    }
    .multiselect__tags,
    .multiselect__single {
      background-color: #f2f2f2 !important;
      border-radius: 4px;
    }
  }

  .input-border-wrapper {
    background-color: #f2f2f2;
    overflow: hidden;
  }

  .input-border {
    border-inline-start: 1px solid #dfdfdf;
    height: 25px;
    position: relative;
    top: 9px;
  }

  .separate-line {
    margin-top: 36px;
  }

  .user-type-separate-line {
    width: 380px;
    height: 8px;
    color: #f7f7f7;
    border: 0px;
    margin: auto;
    margin-top: 34px;
    margin-bottom: 21px;
  }

  ul > div {
    margin-bottom: 30px;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
  .margin-end {
    margin-inline-end: 0.5rem !important;
  }
}
</style>
